module.exports = __webpack_public_path__ + "static/experian-logo-55f02c4d67fdda27e12e4b104a8c207f.png";